import React, { Dispatch, SetStateAction } from "react";
import SearchBar from "../../components/SearchBar";
import { Button, Box, Menu, MenuItem } from "@mui/material";
import { isValidInput } from "../../utils/validations";
import { RoleTypes, SubadminTypes } from "../../types/General";
import { errorToast } from "../../helpers";

type props = {
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  setDebouncedSearchTerm: Dispatch<SetStateAction<string>>;
  roles: RoleTypes[];
  selectedRole: number | null;
  setSelectedRole: Dispatch<SetStateAction<number | null>>;
  handleExportCSV: () => void;
  rows: SubadminTypes[];
};

const UserListFilter = ({
  setOpenModal,
  searchTerm,
  setSearchTerm,
  setDebouncedSearchTerm,
  selectedRole,
  setSelectedRole,
  handleExportCSV,
  rows,
  roles,
}: props) => {
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (roles?.length) {
      setAnchorEl1(event.currentTarget);
    } else {
      errorToast("No roles found");
    }
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            placeholder="Search"
            setDebouncedSearchTerm={setDebouncedSearchTerm}
            value={searchTerm}
            onCross={() => setSearchTerm("")}
            onChange={(val: any) => {
              if (isValidInput(val.target.value)) {
                setSearchTerm(val.target.value);
              }
            }}
          />
        </div>
        <div className="right_s">
          {selectedRole ? (
            <Button
              className="btn btn_highlight"
              onClick={() => setSelectedRole(null)}
            >
              Clear Filters
            </Button>
          ) : null}
          <Box>
            <Button
              className="btn btn_highlight"
              aria-controls={open1 ? "basic-menu1" : undefined}
              aria-haspopup="true"
              aria-expanded={open1 ? "true" : undefined}
              onClick={handleClick1}
            >
              <img src="/static/images/filter_icon.svg" alt="Icon" /> Select
              Role
            </Button>
            <Menu
              className="filter_menu"
              id="basic-menu1"
              anchorEl={anchorEl1}
              open={open1}
              onClose={handleClose1}
              MenuListProps={{
                "aria-labelledby": "basic-button2",
              }}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  boxShadow: "0px 4px 30px 0px rgba(0, 0, 0, 0.13)",
                  borderRadius: "10px",
                  mt: 1,
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              {roles?.length
                ? roles?.map((item) => {
                    return (
                      <MenuItem className="export_btns v2" key={item?.id}>
                        <Button
                          onClick={() => {
                            setSelectedRole(item?.id);
                            handleClose1();
                          }}
                        >
                          {item?.role_name || "-"}
                        </Button>
                      </MenuItem>
                    );
                  })
                : null}
            </Menu>
          </Box>
          <Box>
            <Button
              className="btn btn_highlight"
              onClick={handleExportCSV}
              disabled={!rows?.length}
            >
              <img src="/static/images/upload_icon.svg" alt="Icon" /> Export CSV
            </Button>
          </Box>
          <Button
            className="btn btn_secondary"
            onClick={() => setOpenModal(true)}
          >
            Add Sub-admin
          </Button>
        </div>
      </div>
    </>
  );
};

export default UserListFilter;
